<template>
    <div
        class="competence-levels"
    >
        <CompetenceLevel
            class="test-level"
            label="Уровень по тесту:"
            :currentLevel="item.competenceLevel"
            requiredLevel="advanced"
            :type="item.competenceType"
            name-class="bold"
        />
        <span
            v-if="item.foreignTestId"
            class="test-link"
            @click="startTest"
        >
            Пройти тест заново
        </span>

        <CompetenceLevel
            v-if="item.expertCompetenceLevel"
            class="mb-5 rating"
            label="Оценка эксперта:"
            :currentLevel="item.expertCompetenceLevel"
            requiredLevel="advanced"
            type="expert"
            name-class="bold"
        />

        <CompetenceAcknowledgment
            v-if="item.competenceLevel === null && item.expertCompetenceLevel  === null && !item.foreignTestId"
            class="acknowledgment"
            :item="item"
        />
    </div>
</template>

<script>
import CompetenceLevel from './CompetenceLevel';
import CompetenceAcknowledgment from './CompetenceAcknowledgment';

export default {
    name: 'CompetenceItemLevels',
    components: {
        CompetenceAcknowledgment,
        CompetenceLevel,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },

    methods: {
        startTest() {
            let query = { from: this.$route.fullPath };
            if (this.$store.getters['isMobileApp']) {
                query.is_mobile_app = true;
            }
            window.open(this.$router.resolve({
                name: 'multiple-test-start',
                params: { id: this.item.foreignTestId },
                query,
            }).href, '_blank');
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '~@/styles/rem';
    @import '~@/styles/mrem';

    .test-link {
        font-family: 'Proxima Nova', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: rem(16);
        line-height: rem(24);
        color: #4663AB;
        display: inline-block;
        margin-bottom: rem(16);
        cursor: pointer;

        @include on-mobile {
            font-size: mrem(16);
            line-height: mrem(24);
            margin-bottom: mrem(16);
        }
    }

    .test-level,
    .acknowledgment
    {
        margin-bottom: rem(10);

        @include on-mobile {
            margin-bottom: mrem(10);
        }
    }

    .rating {
        margin-top: rem(10);

        @include on-mobile {
            margin-top: mrem(10);
        }
    }

    .test-btn {
        font-weight: 600;
        width: rem(178);
        font-family: 'Proxima Nova', sans-serif;
        font-style: normal;
        font-size: rem(18) ;
        line-height: rem(26);
        border: rem(2) solid #4663AB;
        border-radius: rem(4);

        @include on-mobile {
            width: mrem(178);
            font-size: mrem(18) ;
            line-height: mrem(26);
            border: mrem(2) solid #4663AB;
            border-radius: mrem(4);
        }
    }
</style>